export default {
  company (state) {
    return state.company
  },
  isImage (state) {
    return typeof state.company.logo === 'object' || state.company.logo === ''
  },
  loadingCompany (state) {
    return state.loadingCompany
  },
  loadingZipCode (state) {
    return state.loadingZipCode
  },
  shelfedLogo (state) {
    return state.logoNotSent
  },
  waitingApproval (state) {
    return state.waitingApproval
  },
  tradingName (state) {
    return state.company.tradingName
  },
  currentPage (state) {
    return state.currentPage
  },
  totalPages (state) {
    return state.totalPages
  },
  totalItems (state) {
    return state.totalItems
  },
  itemsPerPage (state) {
    return state.itemsPerPage
  },
  evaluations (state) {
    return state.evaluations
  },
  users (state) {
    return state.users
  },
  userVisible (state) {
    return state.userModal
  },
  selectedUser (state) {
    return state.selectedUser
  },
  selectedAvaliacao (state) {
    return state.selectedAvaliacao
  },
  evaluationVisible (state) {
    return state.evaluationModal
  }
}



// WEBPACK FOOTER //
// ./src/store/empresa/getters.js